import { authApiService } from '@/api/authApiService';
import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';

export type CreateRecipientPayloadType = {
  email: string;
  mobile_phone: string;
  first_name?: string;
  middle_name?: string;
  last_name?: string;
  is_proxy: boolean;
  is_pd_provider_kyc_required?: boolean;
};

export const createRecipientApi = (
  wireId: string,
  data: CreateRecipientPayloadType
): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/organization/wires/${wireId}/recipient/`;

  return authApiService.POST(uri, data);
};
